import { render, staticRenderFns } from "./gasManagement.vue?vue&type=template&id=08e18a6e&scoped=true&"
import script from "./gasManagement.vue?vue&type=script&lang=js&"
export * from "./gasManagement.vue?vue&type=script&lang=js&"
import style0 from "./gasManagement.vue?vue&type=style&index=0&id=08e18a6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e18a6e",
  null
  
)

export default component.exports